module.exports = __webpack_public_path__ + "static/media/local_shipping_black_24dp.5cf8a1ba.svg";